import React from 'react'

interface WhyItemProps {
  title: string
  description: string
}

const WhyItem: React.FC<WhyItemProps> = ({ title, description }) => (
  <div className='bg-white/[0.03] px-5 py-5 md:px-7 md:py-6 hover:bg-white/[0.06] transition-colors duration-300'>
    <h4 className='font-hd text-[16px] font-bold text-white mb-[0.35rem] tracking-[-0.2px]'>
      {title}
    </h4>
    <p className='text-[13px] text-white/[0.45] leading-[1.55]'>{description}</p>
  </div>
)

const WhyUs: React.FC = () => {
  return (
    <section className='bg-ink py-[5.5rem] scroll-mt-20 px-4 md:px-10' id='why'>
      <div className='max-w-[1060px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center'>
        <div>
          <div className='text-[12px] font-bold tracking-[2px] uppercase text-white/[0.35] mb-3'>
            Why zeiger
          </div>
          <h2 className='font-hd text-[28px] md:text-[42px] font-extrabold text-white tracking-[-1.5px] md:tracking-[-2px] leading-[1.08] mb-4'>
            We&rsquo;re not another
            <br />
            dev shop.
          </h2>
          <p className='text-white/[0.50] text-[16px] leading-[1.7]'>
            You&rsquo;ve probably been burned before — missed deadlines, surprise invoices, junior
            devs doing senior work. We built Zeiger to be the opposite of that.
          </p>
        </div>

        <div className='flex flex-col gap-px bg-white/[0.06] rounded-[12px] overflow-hidden'>
          <WhyItem
            title='Senior engineers only'
            description='No interns. No bait-and-switch. The people in the meeting are the people writing the code.'
          />
          <WhyItem
            title='Fixed scope, fixed price'
            description="We scope aggressively upfront and quote a number. That's the number you pay. Period."
          />
          <WhyItem
            title='Weekly working demos'
            description='You see real progress every single week. Not slide decks. Working software you can click.'
          />
          <WhyItem
            title='We stick around'
            description="Launch isn't the finish line. Ongoing support, monitoring, and iteration after go-live."
          />
        </div>
      </div>
    </section>
  )
}

export default WhyUs
